import axios from "axios";
import moment from "moment";
import bus from "@/EventBus";

export default {
  namespaced: true,
  state: {
    tareas: [],
    tarea: {},
  },
  mutations: {
    llenarTareas(state, data) {
      state.tareas = data;
    },
    llenarTarea(state, data) {
      state.tarea = data;
    },
  },
  actions: {
    getTareas: async function({ commit }, token) {
      let header = { Token: token };
      let configuracion = { headers: header };
      let data = null;

      await axios
        .get("tarea/list", configuracion)
        .then(function(response) {
          response.data.forEach((element) => {
            element.create_at = moment(element.create_at).format("LL");
            element.finish_at = moment(element.finish_at).format("LL");
            if(element.estado == 0) {
                if(element.prioridad == 1) {
                    element.color = '#ffc400'
                } else if(element.prioridad == 2) {
                    element.color = 'orange'
                } else if(element.prioridad == 3) {
                    element.color = 'red'
                } 
            } else {
                element.color = 'green'
            }
            
          });
          data = response.data;
          commit("llenarTareas", data);
        })
        .catch(function(error) {
            swal({
                title: "Lo sentimos!",
                text: `Ha ocurrido un error de tipo ${error} al intentar obtener las tareas. Informe al equipo de desarrollo sobre este error`,
                icon: "error",
              });
          console.log(error);
        });
    },
    getTarea: async function({ commit }, data) {
      let header = { Token: data.token };
      let configuracion = { headers: header };
      let d = null;

      await axios
        .get(`tarea/query?id=${data.id}`, configuracion)
        .then(function(response) {
          d = response.data.detalles;
          commit("llenarTarea", d);
        })
        .catch(function(error) {
          swal({
            title: "Lo sentimos!",
            text: `Ha ocurrido un error de tipo ${error} al intentar obtener esta tarea. Informe al equipo de desarrollo sobre este error`,
            icon: "error",
          });
          console.log(error);
        });
    },
    saveTarea: async function({ dispatch }, data) {
      let header = { Token: data.token };
      let configuracion = { headers: header };
      // debugger

      await axios
        .post(
          "tarea/add",
          {
            creado_por: data.usuario,
            ultimo_editar: data.usuario,
            nombre: data.obj.nombre,
            finish_at: data.obj.finish_at,
            prioridad: data.obj.prioridad,
            comentarios: data.obj.comentarios,
            estado: 0,
          },
          configuracion
        )
        .then(function(res) {
          dispatch("getTareas", data.token);
          swal({
            title: "Buen trabajo!",
            text: `Tarea ${res.data.nombre} agregada correctamente`,
            icon: "success",
          });
        })
        .catch(function(error) {
          swal({
            title: "Lo sentimos!",
            text: `Ha ocurrido un error de tipo ${error}`,
            icon: "error",
          });
        });
    },
    updateTarea: async function({ dispatch }, data) {
      let header = { Token: data.token };
      let configuracion = { headers: header };
      //debugger;
      await axios
        .put(
          "tarea/update",
          {
            id: data.obj.id,
            ultimo_editar: data.usuario,
            nombre: data.obj.nombre,
            finish_at: data.obj.finish_at,
            prioridad: data.obj.prioridad,
            comentarios: data.obj.comentarios,
            estado: data.obj.estado,
          },
          configuracion
        )
        .then(function(res) {
          dispatch("getTareas", data.token);
          swal({
            title: "Buen trabajo!",
            text: `Tarea ${res.data.nombre} editado correctamente`,
            icon: "success",
          });
        })
        .catch(function(error) {
          swal({
            title: "Lo sentimos!",
            text: `Ha ocurrido un error de tipo ${error}`,
            icon: "error",
          });
        });
    },
    deleteTarea: async function({ dispatch }, data) {
      let token = data.token;
      let header = { Token: token };
      let configuracion = { headers: header };
      debugger;
      await axios
        .delete(`tarea/remove?id=${data.id}`, configuracion)
        .then(function() {
          // debugger
          dispatch("getTareas", data.token);
          swal({
            title: "Buen trabajo!",
            text: `Tarea eliminada correctamente`,
            icon: "success",
          });
        })
        .catch(function(error) {
          swal({
            title: "Lo sentimos!",
            text: `Ha ocurrido un error de tipo ${error}`,
            icon: "error",
          });
          console.log(error);
        });
    },
  },
};
